import API_CONFIG, { getApiUrl, getHeaders } from './config';

const workTicketService = {
  /**
   * Fetch pending work tickets for a specific worker type
   * @param {string} type - Worker type: 'COOK' or 'SERVE'
   * @returns {Promise<Object>} Response containing pending tickets
   */
  async getPendingTickets(type) {
    try {
      const url = getApiUrl(`/api/work-tickets/pending/${type}`);
      const response = await fetch(url, {
        method: 'GET',
        headers: getHeaders(true)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error(`Error fetching pending ${type} tickets:`, error);
      throw error;
    }
  },

  /**
   * Mark a work ticket as complete
   * @param {string} ticketId - The ID of the ticket to complete
   * @returns {Promise<Object>} Response containing the updated ticket
   */
  async completeTicket(ticketId) {
    try {
      const url = getApiUrl(`/api/work-tickets/${ticketId}/complete`);
      const response = await fetch(url, {
        method: 'PUT',
        headers: getHeaders(true)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error(`Error completing ticket ${ticketId}:`, error);
      throw error;
    }
  },

  /**
   * Fetch pending cook tickets
   * @returns {Promise<Object>} Response containing pending cook tickets
   */
  async getPendingCookTickets() {
    return this.getPendingTickets('COOK');
  },

  /**
   * Fetch pending serve tickets
   * @returns {Promise<Object>} Response containing pending serve tickets
   */
  async getPendingServeTickets() {
    return this.getPendingTickets('SERVE');
  },

  /**
   * Fetch all tickets assigned to a specific worker
   * @param {string} workerId - Worker ID (e.g. 'CHEF001')
   * @returns {Promise<Object>} Response containing the worker's tickets
   */
  async getWorkerTickets(workerId) {
    try {
      const url = getApiUrl(`/api/work-tickets/worker/${workerId}`);
      const response = await fetch(url, {
        method: 'GET',
        headers: getHeaders(true)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error(`Error fetching tickets for worker ${workerId}:`, error);
      throw error;
    }
  }
};

export default workTicketService;

